import React, { useEffect, useState } from "react";
import routes from "./route";
import * as Layout from "../layout"
import { Navigate, Route, Routes } from "react-router-dom";
import Page404 from "../pages/page404";
import { useSelector } from "react-redux";
import { access, activeSession } from "../redux/reducers/authSlice";
import axios from "axios";
import Loader from "../component/Loader";
import ExternalPage from "../pages/ExternalPage";


const AppRoutes = () => {
   
    const toCamelCase = (input) =>
        input.replace(/(?:^\w|[A-Z]|\b\w)/g, (letter, index) =>
            index === 0 ? letter.toLowerCase() : letter.toUpperCase()
        ).replace(/\s+/g, '');


    const getReactElement = (route) => {
        let screen = toCamelCase(route);
        return React.createElement
            (require(`../pages/${screen}`).default);
    }

    const isActive = useSelector(activeSession);
    const isToken = useSelector(access);
    


    return (
        <>
            
            <Routes>
                {
                    routes.map(({
                        layout,
                        path,
                        childrens,
                        redirect
                    }, parentIndex) => {
                        if (childrens) {
                            const LayoutComponent = Layout[layout]
                            if (path === "/admin") {
                                if (!isActive && !isToken) {
                                    return (
                                        <Route
                                            path={path + "/*"}
                                            key={path}
                                            exact
                                            element={<Navigate to="/auth/login" />}
                                        />
                                    )
                                }
                            }

                            return (
                                childrens.map(({
                                    element,
                                    childPath,
                                }, childIndex) => {
                                    return (


                                        <Route
                                            key={`${parentIndex}_${childIndex}`}
                                            path={`${path}${childPath}`}
                                            exact
                                            element={
                                                <div>
                                                    <LayoutComponent>
                                                        {getReactElement(element)}
                                                    </LayoutComponent>
                                                </div>
                                            }

                                        />

                                    )

                                })
                            )


                        } else {
                            if (path === "/") {
                                return (
                                    <Route
                                        path={path}
                                        exact
                                        element={<Navigate to={redirect} replace={true} />}
                                    />
                                )
                            }

                            if (path === "*") {
                                return (
                                    <Route
                                        path={path}
                                        element={<Page404 />}
                                    />
                                )
                            }

                        }
                    })
                }
                <Route path="/about-us" element={<ExternalPage />} />
                <Route path="/privacy-and-security" element={<ExternalPage />} />
                <Route path="/terms-and-conditions" element={<ExternalPage />} />
            </Routes>
        </>
    )
}
export default AppRoutes